import { useState } from "react";
import { ConsultationFormEditor } from "./ConsultationFormEditor.tsx";
import { ConsultationSubmissions } from "./ConsultationSubmissions.tsx";
// The builder previews the form through the client's own components, so it
// needs the client's stylesheet as well as the admin one.
import "../pages/consultation.css";

interface ConsultationsPanelProps {
  token: string;
  onUnauthorised: () => void;
}

type View = "submissions" | "form";

/**
 * Two related jobs behind one tab: chasing the forms that are outstanding, and
 * editing the questions themselves.
 *
 * Kept together rather than given a tab each because the top-level nav is
 * already six items wide on a phone, and these two are visited for the same
 * reason - the day-to-day one first, which is why it is the default.
 */
export function ConsultationsPanel({
  token,
  onUnauthorised,
}: ConsultationsPanelProps) {
  const [view, setView] = useState<View>("submissions");

  return (
    <section className="page stack-lg">
      <div className="segmented" role="group" aria-label="Consultation section">
        <button
          type="button"
          className={`segmented__option ${view === "submissions" ? "segmented__option--active" : ""}`}
          onClick={() => setView("submissions")}
        >
          Submissions
        </button>
        <button
          type="button"
          className={`segmented__option ${view === "form" ? "segmented__option--active" : ""}`}
          onClick={() => setView("form")}
        >
          The form
        </button>
      </div>

      {view === "submissions" ? (
        <ConsultationSubmissions
          token={token}
          onUnauthorised={onUnauthorised}
        />
      ) : (
        <ConsultationFormEditor token={token} onUnauthorised={onUnauthorised} />
      )}
    </section>
  );
}
